import { isChartHost } from './chart-hosts'

const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const ChartRefactor = () =>
  import(/* webpackChunkName: "chart" */ '../views/ChartRefactor.vue')

const resolveHostComponent = () => (isChartHost() ? ChartRefactor : Home)

const HostRoute = [
  {
    path: '/',
    name: 'index',
    component: resolveHostComponent(),
  },
  {
    path: '/index.html',
    name: 'home',
    component: resolveHostComponent(),
  },
]

export default HostRoute
